import {Observable} from 'rxjs'
import {AjaxCreationMethod} from 'rxjs/internal/observable/dom/AjaxObservable'
import {getHeaders} from '../../app/service-utils'
import {BookMappings} from './books.types'

export const loadBookMappings = (ajax: AjaxCreationMethod): Observable<BookMappings> => {
  return ajax.getJSON(`/api/v1/webc/toc-info/auto-ebooks`, getHeaders())
}
